import React from 'react';
import {Link} from 'react-router-dom';
import Constant from "../../utils/Constant";
import ImageWebp from 'react-image-webp';
import Cookies from 'js-cookie';
import { decrypt, key } from '../../utils/encryptiondecryption';
class UpNextMobile extends React.Component{
  constructor() {
    super();
    const ciphertext = Cookies.get('YUTETOLPBG-ASY1BSBD#!ASDNMlPOS--_AWQQWyADIURYBDSF092B34BSDSEWEWFELPOWD');
    const decryptedText = decrypt(ciphertext, key);
    this.state = {
      auth: {
        device_id: decryptedText.length > 1 ? (decryptedText[0][1] === 'null' ? null : decryptedText[0][1]) : null,
        phone_details: decryptedText.length > 1 ? (decryptedText[1][1] === 'null' ? null : decryptedText[1][1]) : null,
        user_id: decryptedText.length > 1 ? (decryptedText[2][1] === 'null' ? null : decryptedText[2][1]) : null,
        mobile: decryptedText.length > 1 ? (decryptedText[3][1] === 'null' ? null : decryptedText[3][1]) : null,
        package_id: decryptedText.length > 1 ? (decryptedText[4][1] === 'null' ? null : decryptedText[4][1]) : null,
        subscription_expiry_datetime: decryptedText.length > 1 ? (decryptedText[5][1] === 'null' ? null : decryptedText[5][1]) : null,
      },}}

    handleEpisodeList = () => {
      let episodes = "";
      episodes = this.props.data.map((episode,index) => (
          
          <li key={index} className="">
            <div className="prog_sldr_box">
              <div className="prog_sldr_img"><a href={!this.state.auth.user_id ? "/register" : '/watch/'+episode.episode_slug}><ImageWebp webp={episode.episode_thumbnail} src={episode.episode_thumbnail_jpg} alt="Aaj ka Tarka"/>
                <div className="duration_time"><span>{episode.episode_duration}</span></div>
                <div className="hvr_box"><span uk-icon="play"></span></div>
                </a> </div>
              <div className="prog_sldr_text">
                <h4 className="homesectionone"><b><a className="anchor" href={!this.state.auth.user_id ? "/register" : '/watch/'+episode.episode_slug} title={episode.episode_name}>{episode.episode_name}</a></b></h4>
                <p><span>{episode.program_name} </span> <span>{episode.episode_views} views . </span><span>{episode.episode_date}</span> </p>
              </div>
            </div>
          </li>
              
      ));        
      return episodes;
    };  
    render(){
        return (
            <div>
                <ul className="upnext_ul continue_watching_m">
                    {this.handleEpisodeList()}
                </ul>
            </div>
        );
    }
}

export default UpNextMobile;